export const APP_NAME = 'FieldPro Admin';
export const DEFAULT_PAGE_SIZE = 25;

/** The ceiling for a catalog Available Count — Device, Component and Bundle alike — the BA's ruling
 *  on ADO 121208 (28 Sep). The API's own bound is int4, so without it a large count came back as
 *  "The request payload is invalid". */
export const AVAILABLE_COUNT_MAX = 99_999;
